<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="true"/>
  </div>
</template>

<script>
/* eslint-disable indent */
    // import config from '../../config/dev.env.js'
    import axios from 'axios'
    import Vue from 'vue'

    const GET = '/survey/get/'
    const CREATE = '/survey/create'

    export default {
        data () {
            return {
              isLoading: true,
              data: this.$store.getters.getInfo,
              settings: this.$store.getters.getSurveySettings,
              defaultSettings: {
                title: "",
                instructiontext: "",
                required_name: false,
                required_email: false,
                font_color: null,
                primary_color: null,
                secondary_color: null,
                // logo: "https://api.prestatiedatabank.nl/survey/get_logo//template_emet",
                fillable_once: false,
                after_send_message: "Some text",
                before_start_message: "more text",
                expire_message: "even more"
              }
            }
        },
        created () {
          if (this.$route.params.token) {
              this.$store.commit('setToken', this.$route.params.token)
              this.initialize()
          }
          // if (this.$store.getters.getToken) this.displayStart()
        },
        methods: {
            startForm () {
                this.$router.push({name: 'form'})
            },
            initialize () {
              // let activities = null
              let token = this.$store.getters.getToken

              console.log('API request to: ' + process.env.EMET_API_URL + GET + token)

               this.$http
                .get(process.env.EMET_API_URL + GET + token)
                .then((response) => {
                  let settings = this.checkSurveySettings(response.data.form.survey_settings);
                  this.$store.commit('setSurveySettings', settings)
                  // this.$store.commit('setSurvey', response.data.form)
                  this.$store.commit('setActivities', response.data.form.activities)
                  this.$store.commit('setFormlength', this.getFormlength(response.data.form.activities))
                  
                  this.$store.commit('setValidate', false)
                  this.$store.commit('setProject', response.data.project)
                  this.$store.commit('setInfo', response.data.form)
                  this.$store.commit('setStyle', settings)
                  this.setStatus(response.data.form.startdate, response.data.form.expirationdate, response.data.project)
                  this.startForm()
                })
            },
            getFormlength (activities) {
              let count = 0
              if (!activities) activities = [];
              activities.forEach((activity) => {
                activity.questions.forEach((question) => {
                  if (!question.disabled && question.type !== 1) {
                    count += 1
                  }
                })
              })
              return count
            },
            setStatus(start, expired, project) {
              let currentDate = new Date();
              let startDate = new Date(start);
              let expiredDate = new Date(expired);


              if(currentDate < startDate){
                  this.$store.commit('setStatus', 'before_start')
              } else if(currentDate > expiredDate)
              {
                this.$store.commit('setStatus', 'expired')
              } else if (!('_id' in project)) {
                this.$store.commit('setStatus', 'deleted')
              } else {
                this.$store.commit('setStatus', 'start')
              }
              // console.log(this.$store.getters.getStatus)
            },
            checkSurveySettings (settings) {
              let settingsResult = settings;

              // Check if logo is loaded, or replace it with default logo
              // settingsResult.logo = this.imageExists(settings.logo)

              // check if primary color is set
              if (!settings.primary_color || settings.primary_color == undefined) {
                settingsResult.primary_color = "#009DE0";
              }

              // check if secondary color is set
              if (!settings.secondary_color || settings.secondary_color == undefined) {
                settingsResult.secondary_color = "#A1C036";
              }

              // check if font color is set
              if (!settings.font_color || settings.font_color == undefined) {
                settingsResult.font_color = "grey";
              }
              return settingsResult;
            }
            // imageExists (path) {
            //   let image = new Image();
            //   image.src = path;
            //   // return default image if the logo setting results in '0'

            //   let result = '../../static/img/pd_logo_light.png'
            //   setTimeout(function () {
            //     if (image.width != 0) {
            //       result;
            //     } else {
            //       return path;
            //     }
            //   }, 1000)

            // }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Token.vue